export function initToc(container = document, tocSelector = '.toc') {
  // Compatibilité avec l'ancien paramètre tableau
  if (Array.isArray(container)) {
    container.forEach(c => initToc(c, tocSelector));
    return;
  }

  const tocs = container.querySelectorAll(tocSelector);
  if (!tocs.length) return;

  tocs.forEach(toc => {
    // Sélectionner tous les liens du TOC
    const links = toc.querySelectorAll('a[href^="#"]');

    // Smooth scroll + toggle classe active
    links.forEach(link => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        links.forEach(l => l.classList.remove('active'));
        link.classList.add('active');

        const targetId = link.getAttribute('href').slice(1);
        const target = document.getElementById(targetId);
        if (target) {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });

    // Scrollspy
    const sections = Array.from(links)
      .map(link => document.getElementById(link.getAttribute('href').slice(1)))
      .filter(Boolean);

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        const id = entry.target.getAttribute('id');
        const link = toc.querySelector(`a[href="#${id}"]`);
        if (entry.isIntersecting) {
          toc.querySelectorAll('a').forEach(l => l.classList.remove('active'));
          if (link) link.classList.add('active');
        }
      });
    }, {
      root: null,
      rootMargin: '-2% 0px -92% 0px',
      threshold: 0
    });

    sections.forEach(section => observer.observe(section));
  });
}